import React, { useState } from "react";
import { Link } from "react-router";

export default function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
    }
  };

  return (
    <footer id="footer" className="cathedral-footer">
      <div className="container">
        {/* Top Header Banner in Footer */}
        <div className="pb-4 mb-5 border-bottom" style={{ borderColor: "#eae1d1" }}>
          <div className="row g-4 align-items-center justify-content-between">
            <div className="col-lg-4">
              <Link to="/" className="d-flex align-items-center gap-3 text-decoration-none">
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    background: "var(--cathedral-navy)",
                    border: "1.5px solid #b89547",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#f5eedb",
                    fontSize: "1.2rem"
                  }}
                >
                  <i className="fas fa-cross"></i>
                </div>
                <div>
                  <h3 style={{ fontFamily: "'Cinzel', serif", fontSize: "1.35rem", color: "var(--cathedral-navy)", margin: 0, fontWeight: 700 }}>
                    St. Mary's Cathedral
                  </h3>
                  <small style={{ color: "#b89547", letterSpacing: "1.5px", textTransform: "uppercase", fontSize: "0.72rem", fontWeight: 600 }}>
                    Archdiocese of Madurai • Est. 1841
                  </small>
                </div>
              </Link>
            </div>

            {/* Newsletter Subscription */}
            <div className="col-lg-5">
              {subscribed ? (
                <div className="alert alert-success py-2 px-3 mb-0" style={{ fontSize: "0.88rem", borderRadius: "8px" }}>
                  <i className="fas fa-check-circle me-1"></i> Thank you! You will receive parish announcements &amp; feast updates.
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="position-relative">
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control rounded-pill pe-5 py-2 px-4"
                    placeholder="Enter your email for parish updates..."
                    style={{ borderColor: "#decfae", fontSize: "0.9rem", background: "#ffffff" }}
                  />
                  <button
                    type="submit"
                    className="btn btn-cathedral-gold btn-sm rounded-pill position-absolute"
                    style={{ top: "3px", right: "3px", padding: "6px 18px", fontSize: "0.82rem" }}
                  >
                    Subscribe
                  </button>
                </form>
              )}
            </div>

            {/* Social Media Links */}
            <div className="col-lg-3 text-lg-end">
              <div className="d-flex justify-content-lg-end gap-2">
                <a
                  className="footer-social-btn"
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="footer-social-btn"
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="footer-social-btn"
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="footer-social-btn"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 4 Multi-Column Information Grid */}
        <div className="row g-5">
          {/* Column 1: About Cathedral */}
          <div className="col-lg-4 col-md-6">
            <h4 style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>About the Cathedral</h4>
            <p style={{ textAlign: "justify", lineHeight: "1.7", fontSize: "0.92rem", color: "#596a7d" }}>
              St. Mary's Cathedral has an inspiring sacred history of more than 180 years. Bestowed with Cathedral status in 1969, it stands as the mother church of the Roman Catholic Archdiocese of Madurai, displaying a magnificent harmony of Roman, Continental, and European architecture.
            </p>
            <Link to="/history" className="btn btn-sm btn-cathedral-outline" style={{ fontSize: "0.82rem", padding: "6px 16px" }}>
              Read Full History <i className="fas fa-arrow-right ms-1"></i>
            </Link>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h4 style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Navigation</h4>
            <ul className="footer-links">
              <li>
                <Link to="/"><i className="fas fa-angle-right text-secondary"></i> Home</Link>
              </li>
              <li>
                <Link to="/facts"><i className="fas fa-angle-right text-secondary"></i> Parish Facts</Link>
              </li>
              <li>
                <Link to="/history"><i className="fas fa-angle-right text-secondary"></i> Cathedral History</Link>
              </li>
              <li>
                <Link to="/substations"><i className="fas fa-angle-right text-secondary"></i> Substations (14)</Link>
              </li>
              <li>
                <Link to="/parish-admin"><i className="fas fa-angle-right text-secondary"></i> Parish Clergy</Link>
              </li>
              <li>
                <Link to="/photo-gallery"><i className="fas fa-angle-right text-secondary"></i> Photo Gallery</Link>
              </li>
              <li>
                <Link to="/contact"><i className="fas fa-angle-right text-secondary"></i> Contact &amp; Location</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Liturgical Schedule Summary */}
          <div className="col-lg-3 col-md-6">
            <h4 style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Holy Mass Times</h4>
            <div style={{ fontSize: "0.88rem", color: "#596a7d" }}>
              <p className="mb-2">
                <strong style={{ color: "var(--cathedral-navy)" }}>Daily Morning:</strong> 06:00 AM
              </p>
              <p className="mb-2">
                <strong style={{ color: "var(--cathedral-navy)" }}>Daily Evening:</strong> 06:00 PM
              </p>
              <p className="mb-2">
                <strong style={{ color: "var(--cathedral-navy)" }}>Sunday Masses:</strong><br />
                06:00 AM, 07:00 AM &amp; 06:00 PM
              </p>
              <p className="mb-0">
                <strong style={{ color: "var(--cathedral-navy)" }}>Weekly Novenas:</strong><br />
                Tue (St. Antony) • Fri (Sacred Heart) • Sat (Our Lady)
              </p>
            </div>
          </div>

          {/* Column 4: Contact Information */}
          <div className="col-lg-3 col-md-6">
            <h4 style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Cathedral Office</h4>
            <div className="footer-contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>East Veli Street, Madurai,<br />Tamil Nadu 625001, India</span>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-envelope"></i>
              <a href="mailto:stmaryscathedral1841@gmail.com" style={{ color: "#596a7d" }}>
                stmaryscathedral1841@gmail.com
              </a>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-phone-alt"></i>
              <a href="tel:+919176155356" style={{ color: "#596a7d" }}>
                +91 91761 55356
              </a>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-clock"></i>
              <small>Office: Mon–Sat 9:30 AM – 1:00 PM &amp; 4:30 PM – 7:00 PM</small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
